import { useState } from "react";
import { HomeIcon } from "../assets/icons";
import { auth } from "../../services/auth";

export default function LoginForm({ setIsAuthenticated }) {
  const [user, setUser] = useState('')
  const [passwd, setPasswd] = useState('')
  const [sessionToken, setSessionToken] = useState('')
  const [btnContent, setBtnContent] = useState("Entrar");

  const [authStatus, setAuthStatus] = useState('')

  const handleLogin = async () => {
    try {
      const response = await auth(user, passwd)
      setAuthStatus(response.message)
      setIsAuthenticated(response.status)
    } catch (e) {
      console.log('Erro no Login: ', e)
    }
  }

  const fromLoginToHome = () => {
    window.location.href = '/'
  }

  return <>
    {/* Pagina de Login */}
    <header className="fixed w-full bg-transparent p-5">
      <nav className="flex justify-between">
        <button className="flex gap-x-3" onClick={() => fromLoginToHome()}>
          <HomeIcon />
          Voltar ao Site
        </button>
      </nav>
    </header>
    
    <section className="flex justify-center h-screen w-full items-center">
      <div className="bg-[#0001] p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-3xl font-light mb-14 text-center text-white">
          FAI Imoveis | Admin
        </h2>

        <div id="login-form" className="mt-4 text-white" method="post">
          <label htmlFor="username" className="block mb-2">
            Usuário:
          </label>
          <input
            type="text"
            id="username"
            name="username"
            onChange={(e) => setUser(e.target.value)}
            className="w-full text-black p-2 border border-gray-300 rounded-lg mb-4"
            required />
          <label htmlFor="password" className="block mb-2">
            Senha:
          </label>
          <input
            type="password"
            id="password"
            name="passwd"
            onChange={(e) => setPasswd(e.target.value)}
            className="w-full text-black p-2 border border-gray-300 rounded-lg mb-4"
            required />

          {/* <h1 className="text-red-500 my-0"> Credenciais Incorretas </h1> */}

          <h2 className="text-red-500">{ authStatus && (authStatus) }</h2>

          <div
            className="border-b border-blue-500 my-10"
          ></div>

          <button
            className="bg-blue-600 font-thin focus:bg-blue-300 text-white text-xl p-4 rounded-lg w-full h-16 hover:bg-blue-500 transition"
            onClick={handleLogin}
          >
            {btnContent}
          </button>
        </div>
      </div>
    </section>
  </>
}